import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "./Slider.css";

// const slides = [
//   {
//     id: 1,
//     image: "/images/about.jpg",
//     title: "The Best Coffee Testing Experience",
//     description:
//       "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
//   },
//   {
//     id: 2,
//     image: "/images/article.jpg",
//     title: "Amazing Taste & Beautiful Place",
//     description:
//       "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
//   },
//   {
//     id: 3,
//     image: "/images/bg_3.jpg",
//     title: "Creamy Hot and Ready to Serve",
//     description:
//       "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
//   },
// ];

// const HomeSlider = () => {
//   return (
//     <section className="home-slider">
//       <Swiper
//          modules={[Navigation, Pagination, Autoplay]}
//          navigation
//          pagination={{ clickable: false }}
//          autoplay={{ delay: 3000, disableOnInteraction: false }}
//         loop
//         className="swiper-container"
//       >
     
//            <SwiperSlide >
//             <div
//               className="slider-item"
//              style={{ backgroundImage: `url(/images/bg_1.jpg)`,
//            backgroundSize: "cover",
//            backgroundPosition:"center" }}
//             >
//                <div className="overlay"> </div> 
//               <div className="container">
//                 <div className="row slider-text justify-content-center align-items-center">
//                   <div className="col-md-8 col-sm-12 text-center">
//                     <img src="/images/bg_1.jpg" className="img-fluid"/>
//                     <span className="subheading">Welcome</span>
//                     <h1 className="mb-4">lide.title</h1>
//                     <p className="mb-4 mb-md-5">slide.description</p>
//                     <p>
//                       <a href="#" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
//                         Order Now
//                       </a>
//                       <a
//                         href="#"
//                         className="btn btn-white btn-outline-white p-3 px-xl-4 py-xl-3 rounded-0"
//                       >
//                         View Menu
//                       </a>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               </div>
           
//           </SwiperSlide> 
//         <SwiperSlide>
//   <div className="slider slider-item slider-1"> 
//     <div className="overlay"> </div>
//     <div className="container">
//       <div className="row slider-text justify-content-center align-items-center">
//         <div className="col-md-12 col-sm-12 text-center ">
//           <span className="subheading">Welcome</span>
//           <h1 className="mb-4"> The Best Coffee Testing Experience</h1>
//           <p className="mb-4 mb-md-5">A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
//           <p>
//                       <a href="#" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
//                         Order Now
//                       </a>
//                       <a
//                         href="#"
//                         className="btn btn-white btn-outline-white p-3 px-xl-4 py-xl-3 rounded-0"
//                       >
//                         View Menu
//                       </a>
//                     </p>
//         </div>
//       </div>
//     </div>
//   </div>
// </SwiperSlide>
// <SwiperSlide>
//   <div className="slider-item slider-2"> 
//     <div className="overlay"> </div>
//     <div className="container">
//       <div className="row slider-text justify-content-center align-items-center">
//         <div className="col-md-12 col-sm-12 text-center">
//           <span className="subheading">Welcome</span>
//           <h1 className="mb-4"> Amazing Taste & Beautiful Place</h1>
//           <p className="mb-4 mb-md-5">A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
//           <p>
//                       <a href="#" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
//                         Order Now
//                       </a>
//                       <a
//                         href="#"
//                         className="btn btn-white btn-outline-white p-3 px-xl-4 py-xl-3 rounded-0"
//                       >
//                         View Menu
//                       </a>
//                     </p>
//         </div>
//       </div>
//     </div>
//   </div>
// </SwiperSlide>
// <SwiperSlide>
//   <div className="slider-item slider-3"> 
//     <div className="overlay"> </div>
//     <div className="container">
//       <div className="row slider-text justify-content-center align-items-center">
//         <div className="col-md-12 col-sm-12 text-center">
//           <span className="subheading">Welcome</span>
//           <h1 className="mb-4"> Creamy Hot and Ready to Serve</h1>
//           <p className="mb-4 mb-md-5">A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
//           <p>
//                       <a href="#" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
//                         Order Now
//                       </a>
//                       <a
//                         href="#"
//                         className="btn btn-white btn-outline-white p-3 px-xl-4 py-xl-3 rounded-0"
//                       >
//                         View Menu
//                       </a>
//                     </p>
//         </div>
//       </div>
//     </div>
//   </div>
// </SwiperSlide>
//       </Swiper>
//     </section>
//   );
// };

// export default HomeSlider;






const slides = [
  {
    id: 1,
    image: "/images/bg_1.jpg",
    title: "The Best Coffee Tasting Experience",
    description:
      "Enter the world of filter coffee, where antioxidants convey an incredible story of health and energy.",
  },
  {
    id: 2,
    image: "/images/bg_2.jpg",
    title: "Explore the rich Aroma and Quality of Sera coffee",
    description:
      " Unadulterated leading in unique taste, enticing aroma, soothing warmth, quality unique packaging and low price it’s a voyage into the fascinating science behind your favorite filter coffee .",
  },
  {
    id: 3,
    image: "/images/bg_3.jpg",
    title: " A taste of the dedication of a group of coffee farmers",
    description:
      " Coffee beans we directly collect from selected farmers / plantation and deliver to you...our filter coffee is magically to touch your senses wherever you are and help your routine easier.",
  },
];

const HomeSlider = () => {
  return (
    <section className="home-slider">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop
        className="swiper-container"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="slider-item"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="overlay"></div>
              <div className="container">
                <div className="row slider-text justify-content-center align-items-center" >
                  <div className="col-md-12 col-sm-12 text-center" data-aos="fade-up" >
                    <span className="subheading">Welcome</span>
                    <h1 className="mb-4">{slide.title}</h1>
                    <p className="mb-4 mb-md-5">{slide.description}</p>
                    <p>
                      <a href="/shop" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
                        Shop Now
                      </a>
                      {/* <a href="/profile" className="btn btn-white btn-outline-white p-3 px-xl-4 py-xl-3 rounded-0">
                        View Menu
                      </a> */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HomeSlider;
